import React, { useEffect, useState } from 'react';
import { useNavigate} from 'react-router-dom';

interface HeaderProps {
    title: string;
    isSquadPage: boolean;
}

export const Header = ({ title, isSquadPage }: HeaderProps) => {

    const navigate = useNavigate();

    const [isSmallScreen, setIsSmallScreen] = useState(false);

    const headerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: isSmallScreen ? 'column' as 'column' : 'row' as 'row',
    };

    const titleContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    };

    const feedbackButtonStyle = {
        background: 'none',
        border: 'none',
        color: '#8510e6',
        marginLeft: '10px',
        fontSize: '1.1rem',
        cursor: 'pointer',
        textDecoration: 'underline',
        paddingRight: '10px',
        paddingBottom: '10px'
    };

    const teamsButtonStyle = {
        background: 'none',
        border: 'none',
        color: '#8510e6',
        marginLeft: '10px',
        fontSize: '1.1rem',
        cursor: 'pointer',
        textDecoration: 'underline',
        paddingRight: '10px',
        display: !isSmallScreen && isSquadPage ? 'block' : 'none',
    };

    const handleTeamsClick = () => {
        navigate('/')
    };




    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsSmallScreen(true)
            }
        };

        // Initial check
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>

            <div style={headerStyle}>
                {isSquadPage && <button style={teamsButtonStyle} onClick={handleTeamsClick}>Teams</button>}
                <div style={titleContainerStyle}>
                    <h1 style={{ textAlign: 'center' }}>{title}</h1>
                </div>
                <a href="https://forms.gle/a47wATh58ZYahJG19" target="_blank" rel="noopener noreferrer">
                <button style={feedbackButtonStyle}>Feedback</button>
                </a>
            </div>
        </div>
    )
};
